<template>
  <div style="height: 50vh">
    <div v-if="!loading">
      <div class="my-6">
        <h1>Merci {{ name }}</h1>
        <h3>pour votre {{ typeDeDon }} de {{ montantPretty }}!</h3>
      </div>

      <p class="mb-12">
        Grâce à l’appui et la confiance de donatrices et donateurs comme vous, nous poursuivons avec plus d’impact notre mission de promotion et de
        défense des droits humains partout dans le monde.
      </p>
    </div>
    <div v-else>
      <p>Chargement de vos informations...</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sasDeDon: { type: Object }
  },
  data() {
    return {
      name: "",
      typeDeDon: "",
      montantDon: 0,
      loading: false
    }
  },
  computed: {
    montantPretty() {
      return (
        this.montantDon
          .toFixed(2)
          .replace(/\d(?=(\d{3})+\.)/g, "$& ")
          .replace(".", ",") + " $"
      )
    }
  },
  async created() {
    if (!this.sasDeDon) {
      this.loading = true
      this.axios
        .get(process.env.VUE_APP_BASE_URL + "dons/sasDeDon?sasDeDonId=" + this.$route.params.sasDeDonId)
        .then((res) => {
          this.name = res.data.contactDTO.prenom
          this.typeDeDon = res.data.donDTO.typeDeDon.toLowerCase()
          this.montantDon = res.data.donDTO.montantMultipliePar100 / 100
        })
        .finally(() => {
          this.loading = false
        })
    } else {
      this.name = this.sasDeDon.contactDTO.prenom
      this.typeDeDon = this.sasDeDon.donDTO.typeDeDon.toLowerCase()
      this.montantDon = this.sasDeDon.donDTO.montantMultipliePar100 / 100
    }
  }
}
</script>

<style>
</style>